# all template "partials" (includes) that are used client side, must be mapped here
# on the left, the name of the include, on the right, the path to the include relative to this file
module.exports =
  "shared_load-more-deals-cui-udc": require '../../shared/load-more-deals-cui-udc.html.mustache'
  "shared_load-more-deals-legacy": require '../../shared/load-more-deals-legacy.html.mustache'
  "shared_load-more-deals-attributes": require '../../shared/load-more-deals-attributes.html.mustache'
  "shared_load-more-deals-attributes-filter": require '../../shared/load-more-deals-attributes-filter.html.mustache'
  "shared_sold-out": require '../../shared/sold-out.html.mustache'
  "shared_sold-out-template": require '../../shared/sold-out-template.html.mustache'
  "shared_hero-buy-button-text": require '../../shared/hero-buy-button-text.html.mustache'
  "shared_hero-deal-price": require '../../shared/hero-deal-price.html.mustache'
  "shared_deal-price": require '../../shared/deal-price.html.mustache'
